<template>
  <div class="content if-profile competitive report-tab">
    <div class="md-layout industry-sumnary">
      <MRReportHeader :headerData="this.headerData" />

      <div class="md-layout-item p-0">
        <md-card class="if_card">
          <div class="md-layout">
            <div class="md-layout-item md-medium-size-100 md-size-100 p-0">
              <md-card-header class="md-card-header-icon">
                Competitive Summary
                <br />
              </md-card-header>
            </div>
          </div>
          <md-card-content>
            <div class="md-layout p-4">
              <div class="md-layout-item md-medium-size-100 md-size-50">
                <table-card class="md-card-profile">
                  <template slot="header" header-color="rose">
                    <h4 class="title">
                      <div
                        class="md-layout-item md-medium-size-100 md-size-100 card-title p-0"
                      >Competitive Analysis Summary</div>
                    </h4>
                  </template>
                  <template slot="content">
                    <div class="md-layout">
                      <div class="md-layout-item md-size-100 p-0">
                        <md-table v-model="tableDataAnalysisSummary">
                          <md-table-row slot="md-table-row" slot-scope="{ item }">
                            <md-table-cell
                              md-label="Competitive Analysis Summary"
                            >{{ item.profileYear }}</md-table-cell>
                            <md-table-cell md-label>
                              {{
                                item.firms
                              }}
                            </md-table-cell>
                          </md-table-row>
                        </md-table>
                      </div>
                    </div>
                  </template>
                </table-card>
              </div>
              <div class="md-layout-item md-medium-size-100 md-size-50">
                <table-card class="md-card-profile">
                  <template slot="header" header-color="rose">
                    <h4 class="title">
                      <div
                        class="md-layout-item md-medium-size-100 md-size-100 card-title p-0"
                      >Variance from Market Area Industry{{ cmn && cmn.current_year_label ? ' (' + cmn.current_year_label + ')' : '' }}:</div>
                    </h4>
                  </template>

                  <template slot="content">
                    <div class="md-layout">
                      <div class="md-layout-item md-size-100 p-0">
                        <md-table v-model="tableDataVarianceMarketAreaIndustry">
                          <md-table-row slot="md-table-row" slot-scope="{ item }">
                            <md-table-cell md-label>
                              {{
                                item.profileYear
                              }}
                            </md-table-cell>
                            <md-table-cell md-label>
                              {{
                                item.firms
                              }}
                            </md-table-cell>
                          </md-table-row>
                        </md-table>
                      </div>
                    </div>
                  </template>
                </table-card>
              </div>
            </div>
          </md-card-content>
        </md-card>
      </div>
    </div>
  </div>
</template>

<script>
import { TableCard } from '@/components';
import { mapState } from 'vuex';
import MRReportHeader from './_partials/MRReportHeader.vue';

export default {
  components: {
    TableCard,
    MRReportHeader,
  },
  props: ['headerData'],
  data() {
    return {
      showDialog: false,
      tableDataAnalysisSummary: [],
      tableDataVarianceMarketAreaIndustry: [],
      tableDataSalesRank: [],
    };
  },
  computed: {
    ...mapState({
      cmn: (state) => state.user.market_report['data']['cmn'],
      annualSalesRank: (state) =>
        state.user.market_report.data.data['annualSalesRank'],
      annualSalesRankResolved: (state) =>
        state.user.market_report.data.data['annualSalesRankResolved'],
      annualSalesRankResolvedLabel: (state) =>
        state.user.market_report.data.data['annualSalesRankResolvedLabel'],
      inputsAvailable: (state) =>
        state.user.market_report.data['inputsAvailable'],
    }),
    average() {
      if (this.cmn.user_sales_variance > 0) {
        return 'greater than average';
      } else if (this.cmn.user_sales_variance < 0) {
        return 'greater than average';
      } else {
        return '';
      }
    },
  },
  mounted() {
    // Competitive Analysis Summary box. Read the resolved-release scalars emitted by
    // api.app (the release the engine chose as "current"), not tableDataSalesRank[N].dates[1]
    // - that hardcoded the perpetually-empty TTM slot, which is why the box rendered blank.
    // The caption row was also mislabeled "Sales Change (Y1 to Y3)" while it actually shows
    // "Variance from Average Sales (%)"; corrected here to match the data. Guarded on its own
    // so a missing rank payload can no longer blank the variance panel below it.
    const resolved = this.annualSalesRankResolved || {};
    const ylabel = this.annualSalesRankResolvedLabel
      ? ' (' + this.annualSalesRankResolvedLabel + ')'
      : '';
    if (this.annualSalesRankResolved) {
      this.tableDataAnalysisSummary.push(
        {
          profileYear: 'Sales Rank:',
          firms: resolved.sales_rank,
        },
        {
          profileYear: 'Sales Percentile:',
          firms: resolved.sales_rank_per,
        },
        {
          profileYear: 'Variance from Average Sales (%)' + ylabel + ':',
          firms: resolved.variance_average,
        }
      );
    }
    // Render the variance panel only when the report actually has firm inputs. Previously
    // this was gated on annualSalesRank, which is absent for reports whose resolved release
    // sits at an annual slot (no $key>=2 rank rows) - so those input-bearing reports wrongly
    // showed no panel. inputsAvailable is the true signal, and it still hides the panel for
    // no-input reports (where cmn.variance_* are all 0).
    if (this.inputsAvailable) {
    this.tableDataVarianceMarketAreaIndustry.push(
      {
        profileYear: 'Average Site Sales:',
        firms: this.cmn.variance_avg_site,
      },
      {
        profileYear: 'Median Site Sales:',
        firms: this.cmn.variance_median_site,
      },
      {
        profileYear: 'Average Small Business Sales:',
        firms: this.cmn.variance_sb,
      },
      {
        profileYear: 'Average Industry Wage:',
        firms: this.cmn.variance_wage,
      },
      {
        profileYear: 'Sales per Employee:',
        firms: this.cmn.variance_spe,
      },
      {
        profileYear: 'Efficiency Index (SPE/Avg. Wage):',
        firms: this.cmn.efficiency_index,
      },
      {
        profileYear: 'Rent per Employee:',
        firms: this.cmn.variance_rent,
      }
    );
    }
  },
  methods: {},
};
</script>
<style lang="scss">
.marketprof-competitors {
  .dialog-box {
    display: flex;
    justify-content: flex-end;
    margin: 10px 30px;
  }
}

.icon-arrow {
  transform: rotate(180deg) !important;
}
</style>
